import type { DealStageConfig } from "../types";
import { DealStageConfigCreate } from "./DealStageConfigCreate";
import { DealStageConfigEdit } from "./DealStageConfigEdit";
import { DealStageConfigList } from "./DealStageConfigList";

/**
 * Almikia Epic EP (TASK-105): "Etapas" -- direccion-only (see each screen's
 * own `CanAccess` gate). No `show`: the list already surfaces every field a
 * direccion user needs to decide whether to open a stage's edit form.
 */
export default {
  list: DealStageConfigList,
  edit: DealStageConfigEdit,
  create: DealStageConfigCreate,
  recordRepresentation: (record: DealStageConfig) => record.label,
};
